module.exports = __webpack_public_path__ + "img/AnalysisScreenShot3.c0296ca9.png";